import React from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import Login from "components/login/Login";
import logo from '../assets/img/lubeco_smart_without_R-removebg.png'
import loginBg from '../assets/img/login-bg-optimized.jpg'
import PoweredBy from "components/poweredBy/PoweredBy";

const Auth = () => {
  const mainContent = React.useRef(null);
  const location = useLocation();


  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);


  return (
    <>
      <div className="main-content" ref={mainContent}>
        {/* <AuthNavbar /> */}
        <div className="header py-6 py-lg-8" style={{
          height: '100vh',
          gap: '16px',
          backgroundColor: '#26632b',
          boxShadow: 'inset 7px 0px 4px 0px rgba(0, 0, 0, 0.35)',
          position: 'relative',
          padding: '0 15px',
        }}>
          <img
            src={loginBg}
            alt=""
            aria-hidden="true"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: 0,
            }}
          />

          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'linear-gradient(135deg, rgba(38, 99, 43, 0.5) 0%, rgba(29, 123, 3, 0.9) 100%)',
            zIndex: 1
          }}></div>

          <Container style={{ position: 'relative', zIndex: 2 }}>
            <div className="header-body text-center mb-6" style={{

            }}>
              <Row className="justify-content-center">
                <div className="" style={{
                  background: "white",
                  borderRadius: "16px",
                  width: '400px',
                  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.8)'
                }}>
                  <img src={logo} alt="logo" style={{
                    height: 'auto',
                    width: '360px',
                    filter: 'drop-shadow(0px 0px 1px rgba(255, 255, 255, 1)) drop-shadow(1px 1px 1px rgba(255, 255, 255, 1))'
                  }} className="mt--4" />
                </div>
              </Row>
            </div>
            <Row className="justify-content-center" style={{ position: 'relative', zIndex: 2 }}>
              <Login />
            </Row>
          </Container>
          <div style={{ position: "absolute", bottom: "20px", left: "20px", display: "flex", justifyContent: "flex-start", zIndex: 2 }}>
            <PoweredBy />
          </div>
        </div>

      </div >
    </>
  );
};

export default Auth;